// extracted by mini-css-extract-plugin
module.exports = {"procurementIntensity":"ProcurementIntensityOrganism_procurementIntensity__19pnp"};